import React from "react";
import { useTranslation } from "react-i18next";
import {
  LineChart,
  Line,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
  ReferenceDot,
} from "recharts";
import { formatEUR } from "../lib/format";

export default function PriceHistoryChart({ history = [] }) {
  const { t } = useTranslation();
  if (!history?.length) return null;
  const data = history.map((h) => ({ ...h, price: Number(h.price) }));
  return (
    <div data-testid="price-history-chart">
      <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400 font-semibold mb-2">
        {t("vehicle.price_history")}
      </div>
      <div className="h-40 min-h-[10rem]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 10, right: 10, bottom: 0, left: 0 }}>
            <XAxis
              dataKey="date"
              tickFormatter={(d) =>
                new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short" })
              }
              tick={{ fontSize: 10, fill: "#94A3B8" }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`}
              tick={{ fontSize: 10, fill: "#94A3B8" }}
              axisLine={false}
              tickLine={false}
              width={30}
            />
            <Tooltip
              contentStyle={{
                borderRadius: 10,
                border: "1px solid #E2E8F0",
                fontSize: 12,
                padding: "6px 10px",
              }}
              formatter={(v) => [formatEUR(v), t("vehicle.price")]}
              labelFormatter={(l) =>
                new Date(l).toLocaleDateString("it-IT", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              }
            />
            <Line
              type="monotone"
              dataKey="price"
              stroke="#2563EB"
              strokeWidth={2.2}
              dot={{ r: 3, fill: "#2563EB" }}
              activeDot={{ r: 5 }}
            />
            {data.length > 0 && (
              <ReferenceDot
                x={data[data.length - 1].date}
                y={data[data.length - 1].price}
                r={5}
                fill="#10B981"
                stroke="#fff"
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
